import { Navigate } from "react-router-dom";

function isAuthenticated() {
  return !!localStorage.getItem("token");
}

export default function PrivateRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
}
